import React from "react";
import { useMediaQuery } from "../../hooks/useMediaQuery";

const DiscoveryClearFilters = ({
  hasActiveFilters,
  filters,
  positions,
  handleClearFilter,
  handleClearAllFilters,
  getSelectedCountryName,
  getSelectedDivisionCountryName,
  getSelectedCompetitionName,
  loading,
}) => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  if (!hasActiveFilters) return null;

  return (
    <div className="px-4 sm:px-6 lg:px-12 pb-4">
      <div className="flex flex-wrap gap-2 items-center justify-between">
        {/* Individual Clear Buttons - Desktop Only */}
        <div className="hidden sm:flex flex-wrap gap-2 items-center">
          {filters.country && (
            <button
              onClick={() => handleClearFilter("country")}
              className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800 hover:bg-blue-200 transition-colors"
            >
              Player Nationality: {getSelectedCountryName()}
              <svg
                className="w-3 h-3 ml-1"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          )}
          {filters.divisionCountry && (
            <button
              onClick={() => handleClearFilter("divisionCountry")}
              className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800 hover:bg-blue-200 transition-colors"
            >
              Division Country: {getSelectedDivisionCountryName()}
              <svg
                className="w-3 h-3 ml-1"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          )}
          {filters.competition && (
            <button
              onClick={() => handleClearFilter("competition")}
              className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800 hover:bg-blue-200 transition-colors"
            >
              Competition: {getSelectedCompetitionName()}
              <svg
                className="w-3 h-3 ml-1"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          )}
          {filters.position && (
            <button
              onClick={() => handleClearFilter("position")}
              className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800 hover:bg-blue-200 transition-colors"
            >
              Position:{" "}
              {positions.find((p) => p.id === filters.position)?.name ||
                filters.position}
              <svg
                className="w-3 h-3 ml-1"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          )}
          {filters.freeAgentSince && (
            <button
              onClick={() => handleClearFilter("freeAgentSince")}
              className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800 hover:bg-blue-200 transition-colors"
            >
              Free Agent: {filters.freeAgentSince}
              <svg
                className="w-3 h-3 ml-1"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          )}
          {(filters.age_min || filters.age_max) && (
            <button
              onClick={() => {
                handleClearFilter("age_min");
                handleClearFilter("age_max");
              }}
              className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800 hover:bg-blue-200 transition-colors"
            >
              Age: {filters.age_min || "16"}-{filters.age_max || "45"}
              <svg
                className="w-3 h-3 ml-1"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          )}
          {(filters.minMarketValue || filters.maxMarketValue) && (
            <button
              onClick={() => {
                handleClearFilter("minMarketValue");
                handleClearFilter("maxMarketValue");
              }}
              className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800 hover:bg-blue-200 transition-colors"
            >
              Market Value: €{filters.minMarketValue || "0"}-€{filters.maxMarketValue || "∞"}
              <svg
                className="w-3 h-3 ml-1"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          )}
        </div>

        {/* Clear All Button - Desktop: Right side, Mobile: Center below */}
        <div className="hidden sm:block">
          <button
            onClick={handleClearAllFilters}
            className="text-sm text-blue-600 hover:text-blue-800 font-medium px-3 py-1 border border-blue-600 rounded-lg hover:bg-blue-50 transition-colors"
            disabled={loading}
          >
            Clear All
          </button>
        </div>
      </div>

      {/* Mobile: Compact Clear All button */}
      <div className="sm:hidden flex justify-center mt-2">
        <button
          onClick={handleClearAllFilters}
          className="text-xs text-blue-600 hover:text-blue-800 font-medium px-3 py-1.5 border border-blue-600 rounded-lg hover:bg-blue-50 transition-colors w-full max-w-[200px]"
          disabled={loading}
        >
          Clear All Filters
        </button>
      </div>
    </div>
  );
};

export default DiscoveryClearFilters;
